import Basic from '../_layout';
import generator from '../_layout/util';
import AutoHeight from './AutoHeight';

const Layout = generator({
  prefixCls: 'mkui-layout-modal',
})(Basic);
const Toolbar = generator({
  prefixCls: 'mkui-layout-modal-toolbar',
})(Basic);
const Table = generator({
  prefixCls: 'mkui-layout-modal-table',
})(Basic);
Layout.Toolbar = Toolbar;
Layout.TableWrapper = Table;
Layout.AutoHeight = AutoHeight;
export default Layout;
